import VerificationLayout from "../VerificationMethodLayout";

const CertificateUploadVerification = () => {
  return <VerificationLayout verifyType="Domain TXT Record">CertificateUploadVerification</VerificationLayout>;
};

export default CertificateUploadVerification;
